import res1 from "../../assests/restaurant-1.jpeg"
import res2 from "../../assests/restaurant-2.jpg"
import res3 from "../../assests/restaurant-7.jpg"
import res4 from "../../assests/restaurant-4.jpg"
import res5 from "../../assests/restaurant-5.jpeg"
import res6 from "../../assests/restaurant-6.jpg"
import res7 from "../../assests/restaurant-3.jpg"
import res8 from "../../assests/restaurant-8.png"
import popular1 from "../../assests/restaurant-1/popular-1.png"
import popular2 from "../../assests/restaurant-1/popular-2.png"
import popular3 from "../../assests/restaurant-1/popular-3.png"
import dish1 from "../../assests/restaurant-1/dish-1.png"
import dish2 from "../../assests/restaurant-1/dish-2.png"
import dish3 from "../../assests/restaurant-1/dish-3.png"
import { restaurant1Menu } from "./restaurant1"

export const allRestaurants = [ 
    {
        id:1,
        image: res1,
        title: "Ocean Bistro",
        season: "Summer house",
        time: 21,
        delivery: "free",
        rate: 4.6,
        review: 325,
        height: "282px",
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
    {
        id:2,
        image: res2,
        title: "The Flavorful Table",
        season: "Summer house",
        time: 32,
        delivery: "3.0",
        rate: 4.1,
        review: 145,
        height: "252px",
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
    {
        id:3,
        image: res3,
        title: "Garden Dining Room",
        season: "Summer house",
        time: 40,
        delivery: "1.0",
        rate: 4.9,
        review: 249,
        height: "231px",
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
    {
        id:4,
        image: res4,
        title: "North Beach Restaurant",
        season: "Summer house",
        time: 28,
        delivery: "free",
        rate: 3.9,
        review: 189,
        height: "268px",
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
    {
        id:5,
        image: res5,
        title: "Starbelly",
        season: "Summer house",
        time: 50,
        delivery: "2.5",
        rate: 4.3,
        review: 254,
        height: "302px",
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
    {
        id:6,
        image: res6,
        title: "Chewy Balls",
        season: "Summer house",
        time: 38,
        delivery: "free",
        rate: 4.6,
        review: 122,
        height: "228px",
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
    {
        id:7,
        image: res7,
        title: "Ocean Bistro",
        season: "Summer house",
        time: 45,
        delivery: "free",
        rate: 4.5,
        review: 152,
        height: "227px",
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
    {
        id:8,
        image: res8,
        title: "The Table at Season To Taste",
        season: "Summer house",
        time: 30,
        delivery: "1.0",
        rate: 4.1,
        review: 127,
        height: "346px",
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
        
    },
]
